module.exports = __webpack_public_path__ + "static/media/icon-live_feeds.37b021cc.svg";